import React__default, { useState, useCallback, useEffect } from 'react';
import { Avatar } from '@sravni/react-design-system/lib/Avatar';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Cross } from '@sravni/react-icons';
import { RegionDialog } from '@sravni/react-region-dialog';
import { useStyles, preventBodyScroll } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import '../../Providers/UserMenuVisibilityProvider/src/UserMenuVisibilityProvider.js';
import { useUserMenuVisibility } from '../../Providers/UserMenuVisibilityProvider/hooks/useUserMenuVisibility.js';
import { UserMenu } from '../../UserMenu/src/UserMenu.js';
import modules_2054d19b from '../styles/MobileUserBlock.module.less.js';

const MobileUserBlock = (props) => {
    const { user, serviceURL = '/', getServiceUrl, formatPath } = useCustomProps();
    const cx = useStyles(modules_2054d19b);
    const { pushAnalyticEvent } = useAnalyticEvents();
    const [isVisibleRegionDialog, setIsVisibleRegionDialog] = useState(false);
    const [isVisibleUserMenu, setIsVisibleUserMenu] = useUserMenuVisibility();
    const handleUserMenuDropdownButtonCloseClick = useCallback(() => setIsVisibleUserMenu(false), [setIsVisibleUserMenu]);
    const handleUserMenuDropdownButtonOpenClick = useCallback(() => {
        setIsVisibleUserMenu(true);
        pushAnalyticEvent("userMenuShow" /* EVENTS.USER_MENU_SHOW */, { eventLabel: `Профиль|Клик` });
        pushAnalyticEvent("downloadApp" /* EVENTS.DOWNLOAD_APP */, {
            eventAction: 'Показ ссылки в Store',
            eventLabel: `Меню профиля|Общая кнопка и QR`,
        });
    }, [setIsVisibleUserMenu, pushAnalyticEvent]);
    const handleRegionDialogCloseClick = useCallback(() => setIsVisibleRegionDialog(false), [setIsVisibleRegionDialog]);
    const handleRegionSelectClick = useCallback(() => setIsVisibleRegionDialog(true), [setIsVisibleRegionDialog]);
    const handleRegionDialogChange = useCallback((region) => {
        pushAnalyticEvent("regionDialogClick" /* EVENTS.REGION_DIALOG_CLICK */, { eventLabel: region.name });
    }, [pushAnalyticEvent]);
    useEffect(() => {
        preventBodyScroll(isVisibleUserMenu);
        return () => preventBodyScroll();
    }, [isVisibleUserMenu]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Space, { align: "center", "data-qa": "MobileUserBlock", ...props },
            isVisibleUserMenu ? (React__default.createElement(Button, { className: cx('closeDialogButton'), size: 36, variant: "primary", color: "gray", onClick: handleUserMenuDropdownButtonCloseClick },
                React__default.createElement(Icon, { icon: React__default.createElement(Cross, null) }))) : null,
            user?.sub && !isVisibleUserMenu ? (React__default.createElement(Avatar, { size: 36, src: `//f.sravni.ru/avatars/${user.sub}.svg`, onClick: handleUserMenuDropdownButtonOpenClick })) : null),
        React__default.createElement("div", { className: cx('dropdown', { dropdownVisible: isVisibleUserMenu }) },
            React__default.createElement(UserMenu, { onRegionSelectClick: handleRegionSelectClick })),
        React__default.createElement(RegionDialog, { fullscreen: true, serviceURL: serviceURL, getServiceUrl: getServiceUrl, formatPath: formatPath, visible: isVisibleRegionDialog, onClose: handleRegionDialogCloseClick, onChange: handleRegionDialogChange })));
};
MobileUserBlock.displayName = 'MobileUserBlock';

export { MobileUserBlock };
//# sourceMappingURL=MobileUserBlock.js.map
